import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ErrorState } from '../../../components/states';
import TutorForm from '../../../components/forms/TutorForm';
import Loader from '../../../components/Loader';
import { useFetch } from '../../../hooks/useFetch';

export default function TutorsEditPage() {
  const { itemId } = useParams();

  const { requestApi, data, error } = useFetch(`/v1/admin/users/${itemId}`);

  useEffect(() => {
    requestApi('get');
  }, []);

  if (error) {
    return <ErrorState onRetry={() => requestApi('get')} />;
  }

  return data?.data ? <TutorForm defaultValues={data?.data} /> : <Loader />;
}
